/* Pre-order ship estimate on product cards.
   Figma 588:942 (Rebuy widget 314223) and 622:2402 (Kimonix sections).

   Why this is not pdp2026-preorder.js
   -----------------------------------
   The PDP row reads the message Globo injects into the page
   (.gPreorderTopMessage). That element only ever describes the product the PDP
   is showing, so a carousel of *other* products has nothing to read.

   Globo loads its whole pre-order catalogue into the page instead, and exposes
   a resolver over it:

     Globo.Preorder.settings.products            every pre-order product, by handle and id
     Globo.Preorder.getProductProfile(p, vid)    -> { isPreorder, message: {...}, ... }

   getProductProfile is synchronous and reads already-loaded data, so a card
   costs no request. Verified live: asking for a Rebuy card's product on an
   unrelated PDP returned
   "In High Demand: Expected to Ship by Nov 07, 2026".

   Wording differs by surface on purpose: the PDP says "Est. ships week of
   Nov 7", the cards say "Est. ships Oct 17" (no "week of"). Same date, so the
   prefix lives here rather than in the parser.

   Markup contract -- a card renders this, hidden, and we fill it:

     <div class="ettika-preorder-note" data-preorder-slot
          data-preorder-handle="..." data-preorder-id="..."
          data-preorder-variant="..." hidden>
       <span class="ettika-preorder-note__dot" aria-hidden="true"></span>
       <span class="ettika-preorder-note__text"></span>
     </div>

   Nothing is shown unless Globo says the product is on pre-order, so a card
   whose product is not in the catalogue simply stays hidden. */
(function () {
  if (window.EttikaPreorderCard) return;

  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var PREFIX = 'Est. ships';

  function globo() {
    var P = window.Globo && window.Globo.Preorder;
    return P && P.settings && P.settings.products && P.getProductProfile ? P : null;
  }

  /* Globo's message is whatever the merchant configured around its
     :shipping_date token. Pull the date out and restate it in the design's
     words. The date is used exactly as the app states it -- never rounded
     earlier, because a pre-order promise must not appear sooner than the app
     says. If no date can be parsed the app's own sentence is shown unchanged
     rather than hiding a product that genuinely is on pre-order. */
  function shipDate(message) {
    var m = message.match(/\b([A-Z][a-z]{2})[a-z]*\.?\s+(\d{1,2})(?:[a-z]{2})?(?:,?\s*(\d{4}))?/);
    if (!m) return '';
    var month = MONTHS.indexOf(m[1]);
    if (month < 0) return '';
    var day = parseInt(m[2], 10);
    if (!day) return '';
    return MONTHS[month] + ' ' + day;
  }

  function findProduct(P, handle, id) {
    var list = P.settings.products;
    var i;
    if (handle) {
      for (i = 0; i < list.length; i++) {
        if (list[i].handle === handle) return list[i];
      }
    }
    if (id) {
      for (i = 0; i < list.length; i++) {
        if (String(list[i].id) === String(id)) return list[i];
      }
    }
    return null;
  }

  /* Returns the label for a card, or '' when the product is not on pre-order. */
  function labelFor(handle, id, variantId) {
    var P = globo();
    if (!P) return '';

    var product = findProduct(P, handle, id);
    if (!product) return '';

    /* A profile can be variant-specific, so pass a variant when the card knows
       which one it is showing. Fall back to the product's own first available
       variant rather than guessing. */
    var vid = variantId;
    if (!vid) {
      var fav = product.first_available_variant;
      if (fav && fav.id) vid = fav.id;
      else if (product.variants && product.variants[0]) vid = product.variants[0].id;
    }

    var profile;
    try {
      profile = P.getProductProfile(product, vid);
    } catch (e) {
      return '';
    }
    if (!profile || !profile.isPreorder) return '';

    var message = (profile.message && profile.message.messageAboveText) || '';
    message = String(message).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    if (!message) return '';

    var when = shipDate(message);
    return when ? PREFIX + ' ' + when : message;
  }

  function fill(slot) {
    var text = slot.querySelector('.ettika-preorder-note__text');
    if (!text) return;

    var label = labelFor(
      slot.getAttribute('data-preorder-handle'),
      slot.getAttribute('data-preorder-id'),
      slot.getAttribute('data-preorder-variant')
    );

    if (!label) {
      slot.setAttribute('hidden', '');
      return;
    }
    if (text.textContent !== label) text.textContent = label;
    slot.removeAttribute('hidden');
  }

  function decorate(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var slots = scope.querySelectorAll('[data-preorder-slot]');
    for (var i = 0; i < slots.length; i++) fill(slots[i]);
  }

  /* Globo's embed and the two widgets all arrive on their own schedule, and the
     widgets re-render on carousel paging and variant changes. Rather than
     racing any of them, re-run whenever cards appear. The observer is cheap
     because fill() does no work for a product Globo does not know. */
  /* setTimeout rather than requestAnimationFrame: rAF is paused entirely while
     the tab is in the background, so a PDP opened in a new tab rendered its
     carousels and then sat there with every row still hidden until the shopper
     switched to it. setTimeout is throttled in that state but still runs. */
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      decorate(document);
    }, 50);
  }

  function start() {
    decorate(document);
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    /* A variant change rewrites data-preorder-variant without adding any nodes,
       so childList alone would miss it. */
    new MutationObserver(schedule).observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-preorder-variant'],
    });

    /* The observer alone is not enough, because the two sides arrive in either
       order and only one of them is a DOM mutation:

         cards first, Globo later  -> the observer fired while the catalogue was
                                      still empty, so every row stayed hidden
         Globo first, cards later  -> the observer catches it

       An earlier version stopped polling the moment Globo appeared, which in
       practice is long before the carousels render -- so the first case was
       left with nothing to re-trigger it and the rows never filled.

       So just re-check on a bounded schedule instead. decorate() is a document
       query plus a lookup that returns nothing for a product Globo does not
       know, so an idle pass costs effectively nothing. */
    var waited = 0;
    var timer = setInterval(function () {
      waited += 500;
      decorate(document);
      if (waited >= 30000) clearInterval(timer);
    }, 500);

    /* A tab restored from the background may have rendered its carousels while
       throttled; catch up as soon as it is visible again. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) decorate(document);
    });
  }

  window.EttikaPreorderCard = { labelFor: labelFor, decorate: decorate };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
